import { render, staticRenderFns } from "./ModalForm.vue?vue&type=template&id=0c61fda2&scoped=true&"
import script from "./ModalForm.vue?vue&type=script&lang=js&"
export * from "./ModalForm.vue?vue&type=script&lang=js&"
import style0 from "./ModalForm.vue?vue&type=style&index=0&id=0c61fda2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c61fda2",
  null
  
)

export default component.exports